<script>
import CalendarDateDay from './CalendarDateDay.vue';
import CalendarDateMonth from './CalendarDateMonth.vue';
import { getFormattedDate } from '../../calendar/utils/date-helper.js';

export default {
    name: 'CalendarDate',
    props: {
        date: {
            type: Date,
            required: true
        },
        dateConfig: {
            type: Object,
            default: () => ({ years: [], months: [], days: [] })
        },
        isDesktop: {
            type: Boolean,
            default: true
        }
    },
    components: {
        CalendarDateDay,
        CalendarDateMonth
    },
    methods: {
        setYear(year) {
            const date = new Date(this.date);
            date.setFullYear(year);
            this.setDate(date);
        },
        setMonth(month) {
            const date = new Date(this.date);
            date.setMonth(month, 1);
            this.setDate(date);
        },
        setDate(date) {
            this.$emit('update-date', new Date(date));
        }
    },
    computed: {
        formattedDate() {
            return getFormattedDate(this.date);
        }
    }
};
</script>

<template>
    <div class="w-full">
        <div
            v-if="isDesktop"
            :class="[
                isDesktop &&
                    'rounded-t-block bg-blue-lightest overflow-hidden py-4 pr-4'
            ]"
        >
            <slot name="years" :years="dateConfig.years" :setYear="setYear">
                <ul class="flex flex-wrap p-4">
                    <li
                        v-for="(year, index) in dateConfig.years"
                        :key="index"
                        class="mr-[156px]"
                        @click="setYear(year)"
                    >
                        <CalendarDateYear
                            :year="year"
                            :formatted-date="formattedDate"
                        />
                    </li>
                </ul>
            </slot>
        </div>
        <div :class="[isDesktop ? 'calendar-content w-full pt-6 pb-8' : '']">
            <slot
                name="months"
                :months="dateConfig.months"
                :setMonth="setMonth"
            >
                <ul class="mb-6 flex flex-wrap">
                    <li
                        v-for="(month, index) in dateConfig.months"
                        :key="index"
                        class="mr-[88px] last:mr-0"
                        @click="setMonth(index)"
                    >
                        <CalendarDateMonth
                            :formatted-date="formattedDate"
                            :month="month"
                            :index="index"
                        />
                    </li>
                </ul>
            </slot>
            <slot name="days" :days="dateConfig.days" :setDate="setDate">
                <ul class="grid grid-cols-7 gap-6">
                    <li
                        v-for="day in dateConfig.days"
                        :key="day"
                        @click="setDate(day)"
                    >
                        <CalendarDateDay
                            :formatted-date="formattedDate"
                            :day="day"
                        />
                    </li>
                </ul>
            </slot>
        </div>
    </div>
</template>
